module.exports = __webpack_public_path__ + "img/icon-arrow-down.e0322616.svg";